export const REQUEST_TYPE = {
    GET: 'get',
    POST: 'post',
    DELETE: 'delete',
    PUT: 'put',
    PATCH: 'patch',
};
